module.exports = __webpack_public_path__ + "static/media/person3.6b2565da.jpg";